import {ResponseValidator} from './../utils/response-validator';
import {Observable} from 'rxjs';
import {CanSaveInStorage} from './CanSaveInStorage';
/**
 * A class that help saving API responses in memory
 * using the request payload or provided lookup key
 *
 * To save a request
 * ```
 * this.pushToQ(requestObj, response);
 *
 * // or
 * this.pushToQ(requestObj, response, 'time In Milliseconds');
 * // or
 * // skip response validation
 * this.pushToQ(requestObj, response, null, false);
 *
 * ```
 *
 * To retrieve a request
 *
 * (): Observable<any> => {
 *    return (this.pullFromMemory(requestObj)
 *        || this.httpClient.post('/api', requestObj)
 * }
 */
export class CanSaveInMemory extends CanSaveInStorage {
  constructor() { super(); }
  public responseQ: any = [];
  /**
   * Pull request from previous response
   * param req | object
   * returns saved response | null
   */
  pullFromQ(req: string): any | null {
    const prevR = this.responseQ.filter(r => r.request === req);
    if (prevR && prevR.length) {
      if (prevR[0].expire) {
        if (prevR[0].expire > new Date().getTime()) {
          return prevR[0];
        } else {
          this.responseQ = this.responseQ.filter(r => r.request !== req);
        }
      }
    }
    return null;
  }
  /**
   * Add recently made requests to Q
   * Exclude failure calls, or status code other than 0000
   * param req | object
   * param res | object
   * param ttl | time to live in milliseconds, default is 24 hours
   */
  pushToQ(req: any, response, ttl_mlsc = (1000 * 60 * 60 * 24), validate: boolean = true) {
    if (new ResponseValidator(response).status || !validate) {
      this.responseQ.push({
        expire: new Date().getTime() + ttl_mlsc, // 24 hours
        request: typeof req !== 'string' ? JSON.stringify(req) : req,
        response: response
      });
    }
    return response;
  }
  pullFromMemory(slots) {
    const saved = this.pullFromQ(JSON.stringify(slots));
    if (!saved) {
      return null;
    }
    const c = new Observable(observer => {
      observer.next(saved.response);
      observer.complete();
    });
    return c;
  }
  /**
   * If response is valid, invalidate Q
   * to force fetching from server
   * param response | CVS response
   * returns response | CVS response
   */
  shouldInvalidateQ(response) {
    if (new ResponseValidator(response).status) {
      this.responseQ = [];
    }
    return response;
  }
}
